import React from 'react';

export const StatCard = ({ label, value, accent = '#00ff88', icon }) => (
  <div style={S.card}>
    <div style={S.icon}>{icon}</div>
    <div style={{ ...S.value, color: accent }}>{value ?? '—'}</div>
    <div style={S.label}>{label}</div>
    <div style={{ ...S.glow, background: accent }} />
  </div>
);

const S = {
  card: {
    background: '#0d1117', border: '1px solid #1e2d3d', borderRadius: 12,
    padding: '20px 24px', position: 'relative', overflow: 'hidden',
    flex: '1 1 160px',
  },
  icon: { fontSize: 22, marginBottom: 8 },
  value: { fontFamily: "'Space Mono',monospace", fontSize: 28, fontWeight: 700, lineHeight: 1 },
  label: { fontSize: 11, color: '#7a94b0', textTransform: 'uppercase', letterSpacing: '0.08em', marginTop: 6 },
  glow: { position:'absolute', bottom:0, left:0, right:0, height:2, opacity:0.6 },
};
